
































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";
import _ from "@/boot/lodash";

// Component
import Treeselect from "@riophae/vue-treeselect";

// Treeselect Styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

// Mixins
import CurrenciesStore from "@/mixins/constants/currenciesStore";
import BillingCyclesStore from "@/mixins/constants/billingCyclesStore";
import HasValidation from "@/mixins/HasValidation";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { IState } from "@/store";
import {
  IPricelist,
  IProductPriceMatrix,
  IProductPriceMatrixShort
} from "@/models/products";
import { ICurrency } from "@/models/constants";
import { IBillingTermsOption } from "@/models/constants";

@Component({
  computed: {
    ...mapState({
      priceLists(state: IState, getters) {
        return getters[`data/listArray`]({
          storeModule: DataModules.PRICELISTS,
          scope: this.priceListsScope
        });
      },
      priceListsScope(state: IState, getters) {
        return getters[`data/${DataModules.PRICELISTS}/priceListsScope`](
          this.brandId
        );
      }
    })
  },
  components: {
    "product-price-matrix": () =>
      import(
        "@/components/app/admin/catalogue/products/billing/productPriceMatrix.vue"
      ),
    Treeselect
  }
})
export default class AutoPopulatePricesModal extends Mixins(
  CurrenciesStore,
  BillingCyclesStore,
  HasValidation
) {
  // Map state

  public priceListsScope!: string;
  public priceLists!: IPricelist[];

  // Props

  @Prop({ required: true })
  public prices!: IProductPriceMatrix[];

  @Prop({ required: true })
  public activePriceListId!: IPricelist["id"];

  @Prop({ required: true })
  public usedCurrencies!: ICurrency[];

  @Prop({ default: false })
  public useYearsOnly!: boolean;

  // Variables

  public isLoading = true;
  public isReloading = false;
  public requestError = false;

  public form: any = {
    usedTerm: 12,
    selectedTerms: [],
    prices: [],
    overwrite: false
  };
  public formPrices = [];
  public savedFormPrices = {
    12: [] as IProductPriceMatrixShort[],
    1: [] as IProductPriceMatrixShort[]
  };
  public formCurrencies: ICurrency[] = [];
  public productPricesMatrixUUID = "";

  // Life cycle methods

  public async created() {
    this.loadData();
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binList", {
      storeModule: DataModules.PRICELISTS,
      scope: this.priceListsScope,
      vm: this
    });
  }

  // Methods

  public async loadData() {
    try {
      await Promise.all([
        this.getPriceLists(),
        this.getCurrencies(),
        this.getBillingCycles()
      ]);

      this.initialiseForm();
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    } finally {
      this.isLoading = false;
      this.isReloading = false;
    }
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public getPriceLists() {
    return this.$store.dispatch(`data/${DataModules.PRICELISTS}/list`, {
      scope: this.priceListsScope,
      vm: this,
      params: { limit: 0, with: "parents" }
    });
  }

  public initialiseForm() {
    this.formCurrencies = this.usedCurrencies;
    this.form.selectedTerms = _.map(this.allAvailableTerms, term => term.value);
    this.savedFormPrices[this.form.usedTerm] = _.map(
      _.filter(this.prices, price => {
        return (
          price.billing_cycle_months === this.form.usedTerm &&
          price.pricelist_id === this.activePriceListId
        );
      }),
      price => {
        return {
          ...price,
          currency_code: _.get(
            _.find(this.currencies, ["id", price.currency_id]),
            "code"
          ),
          own_price: true
        };
      }
    );
    this.setFormPrices();
  }

  public setFormPrices() {
    this.savedFormPrices[this.form.usedTerm === 1 ? 12 : 1] = _.map(
      this.form.prices,
      price => {
        return {
          ...price,
          currency_code: _.get(
            _.find(this.currencies, ["id", price.currency_id]),
            "code"
          ),
          own_price: true
        };
      }
    );

    this.$set(this, "formPrices", this.savedFormPrices[this.form.usedTerm]);
    this.productPricesMatrixUUID = this.$uuid();
  }

  public async validateBeforeSubmit() {
    try {
      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }

      this.$emit("success", this.form);
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    }
  }

  public async addCurrency() {
    this.$store.dispatch(
      `data/${DataModules.CATALOGUE_CATEGORIES}/openSelectProductCurrencyModal`,
      {
        props: {
          currencies: this.currencies,
          usedCurrenciesIds: _.map(
            this.formCurrencies,
            (usedCurrency: ICurrency) => usedCurrency.id
          ),
          isMultiple: true
        },
        events: {
          success: results => {
            this.addNewCurrencies(results);
          }
        }
      }
    );
  }

  public async addNewCurrencies(currenciesIds) {
    _.forEach(currenciesIds, currencyId => {
      this.formCurrencies.push(
        _.find(this.currencies, ["id", currencyId]) as ICurrency
      );
    });
  }

  public async removeCurrency(currencyId: ICurrency["id"]) {
    this.formCurrencies = _.filter(
      this.formCurrencies,
      currency => currency.id !== currencyId
    );
  }

  // Computed

  public get availableTerms() {
    return _.filter(
      _.cloneDeep(this.billingTermsOptions),
      term => term.value === 1 || term.value === 12
    );
  }

  public get allAvailableTerms() {
    return _.map(
      _.filter(
        _.cloneDeep(this.billingTermsOptions),
        (billingTerm: IBillingTermsOption) =>
          billingTerm.value !== 0 &&
          (this.useYearsOnly ? billingTerm.value >= 12 : true)
      ),
      term => {
        return {
          ...term,
          id: term.value
        };
      }
    );
  }

  public get activePricelist() {
    return _.find(this.priceLists, ["id", this.activePriceListId]);
  }

  public get productPricesMatrixKey() {
    return `${this.activePriceListId}_${this.productPricesMatrixUUID}`;
  }

  public get usedTerms() {
    return [this.form.usedTerm];
  }

  public get formIsDisabled() {
    return (
      !this.form.prices.length ||
      this.hasErrors ||
      this.isLoading ||
      this.isReloading ||
      this.requestError
    );
  }
}
